import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from "react-router";
import { LinkContainer, IndexLinkContainer } from 'react-router-bootstrap';
import { Nav, NavItem, Navbar, Row, Col } from 'react-bootstrap';

import * as actions from './../../actions/userActions';
import isUnderwriter from '../../utils/is-underwriter'
import _some from 'lodash/some';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import Logo from '../shared/Logo';
import routes from './../../constants/routes';
import { signOut, signOutIdx } from '../../../lib/authentication';
import { OKTA_VERSIONS } from '../../constants'

const HIDE_NAVBAR = [routes.IMPLICIT_CALLBACK, routes.COMPLETE_INVITE, routes.COMPLETE_PROFILE]

export class Header extends Component {
    static propTypes = {
        location: PropTypes.object.isRequired,
    };
    canManageUsers() {
        if (!this.props.user) return false;
        if (this.props.user.role.includes('admin')) return true; // for legacy users!!!
        if (!this.props.user.permissions) return false;

        return _some([
            this.props.user.permissions.includes('underwriters:write'),
            this.props.user.permissions.includes('brokers:write')
        ]);
    }

    canManageBrokerages() {
        if (!this.props.user || !this.props.user.permissions) return false;
        return _some([
            this.props.user.permissions.includes('brokers:read'),
            this.props.user.permissions.includes('brokers:write')
        ]);
    }

    isUnderwriter() {
        const { user } = this.props;
        if (!user || !user.role) return false;
        return isUnderwriter(user)
    }

    async logout() {
        try {
            if (OE_ENV.OKTA_VERSION === OKTA_VERSIONS.V2) {
                await signOutIdx();
            } else {
                await signOut();
            }
        } catch (error) {
            console.log(error)
        }
    }

    render() {
        const { location: { pathname } } = this.props;
        if (HIDE_NAVBAR.includes(pathname)) return null

        const signedIn = !!this.props.user;
        const isUnderwriter = this.isUnderwriter();

        return (
            <Navbar fluid>
                <div className="container">
                    <div className="row">
                        <div className="col-12">
                            <Navbar.Header>
                                <Row>
                                    <Col xs={10} sm={8}>
                                        <Navbar.Brand>
                                            <Link to="/submissions">
                                                <Logo className="logo" />
                                                <h1>Owner&apos;s Edge</h1>
                                            </Link>
                                        </Navbar.Brand>
                                    </Col>
                                    <Col xs={2}>
                                        <Navbar.Toggle />
                                    </Col>
                                </Row>
                            </Navbar.Header>
                            <Navbar.Collapse>
                                <Nav pullRight>
                                    {signedIn && (
                                        <IndexLinkContainer to="/submissions">
                                            <NavItem className="nav-link" eventKey={1}>
                                                Submissions
                                                </NavItem>
                                        </IndexLinkContainer>
                                    )}

                                    {!signedIn && (
                                        <LinkContainer to="/login">
                                            <NavItem className="nav-link" eventKey={3}>
                                                Login
                                                </NavItem>
                                        </LinkContainer>
                                    )}

                                    {this.canManageBrokerages() && (
                                        <LinkContainer to="/brokerages">
                                            <NavItem className="nav-link" eventKey={5}>
                                                {isUnderwriter ? 'Brokers' : 'Brokerages'}
                                            </NavItem>
                                        </LinkContainer>
                                    )}

                                    {this.canManageUsers() && (
                                        <LinkContainer onMouseUp={this.resetEdit} to="/users">
                                            <NavItem className="nav-link" eventKey={4}>
                                                {isUnderwriter ? 'Underwriters' : 'Manage Users'}
                                            </NavItem>
                                        </LinkContainer>
                                    )}

                                    {signedIn && (
                                        <IndexLinkContainer to="/faq">
                                            <NavItem className="nav-link" eventKey={4}>
                                                FAQ
                                            </NavItem>
                                        </IndexLinkContainer>
                                    )}

                                    {signedIn && (
                                        <NavItem
                                            onClick={this.logout}
                                            className="nav-link last"
                                            eventKey={4}
                                        >
                                            Log Out
                                            </NavItem>
                                    )}
                                </Nav>
                            </Navbar.Collapse>
                        </div>
                    </div>
                </div>
            </Navbar>
        );
    }
}

Header.propTypes = {
    user: PropTypes.object,
}

export default connect(
    store => {
        return {
            user: store.user
        };
    },
    actions,
    null,
    { pure: false }
)(withRouter(Header));
